module.exports = __webpack_public_path__ + "static/img/propuestas-2.7fd54cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/propuestas-2.jpg
// module id = ul9p
// module chunks = 1